import React from 'react'

import { Form, Divider, Button, Col, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as UbicacionAlmacenamientoCrud from 'services/ubicacionAlmacenamiento.service'
import * as TempInventarioCrud from 'services/tempInventario.service'

import ImportarRegistrosModal from './modals/importarRegistros'

import { DownloadAxiosFile } from 'utils'

const UbicacionSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const [checkAll, setCheckAll] = React.useState(false)
  const [ubicaciones, setUbicaciones] = React.useState([])

  const [mostrarImportarRegistrosModal, setMostrarImportarRegistrosModal] = React.useState(false)

  const reloafRef = React.useRef(1)

  React.useEffect(() => {
    UbicacionAlmacenamientoCrud.getUbicacionesAlmacenamiento_Select().then(({ data }) => {
      setUbicaciones(data)
    })
  }, [])

  const checkOptionHandler = ({ _id }) => {
    reloafRef.current = reloafRef.current + 1
    setCheckAll(false)
    setUbicaciones(prev => {
      return prev.map(x => {
        return {
          ...x,
          checked: x._id === _id ? !x.checked : x.checked
        }
      })
    })
  }

  const seleccionarTodosClick = () => {
    reloafRef.current = reloafRef.current + 1
    setCheckAll(prevChecked => {
      setUbicaciones(prev => {
        return prev.map(x => ({
          ...x,
          checked: !prevChecked
        }))
      })

      return !prevChecked
    })
  }

  const clickDescargarPlantillaHadler = e => {
    e.preventDefault()
    const selected = ubicaciones.filter(x => x.checked).map(x => x._id)

    TempInventarioCrud.getPlantillaUbicaciones({ ubicaciones: selected })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'Plantilla Inventario Fisico - Ingreso Masivo Por Ubicaciones.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <>
      <Row className='px-5'>
        <Col md={4}>
          <Row>
            <Col md={12}>
              <Form.Checkbox
                name='checkSeleccionar'
                label='SELECCIONAR TODAS'
                id='checkbox-marca-seleccionarTodas'
                checked={checkAll}
                onChange={seleccionarTodosClick}
              />
            </Col>
          </Row>
          <Divider noMargin />
          <Row>
            <Col md={12}>
              <div>
                {ubicaciones.map(x => (
                  <Form.Checkbox
                    key={`${x._id}${reloafRef.current}`}
                    label={x.codigo}
                    id={`checkbox-ubicacion-${x._id}`}
                    checked={x.checked}
                    onChange={e => checkOptionHandler({ _id: x._id })}
                  />
                ))}
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={8} className='text-right'>
          <Button onClick={clickDescargarPlantillaHadler}>Descargar Plantilla</Button>
          <Button className='ml-3' onClick={e => setMostrarImportarRegistrosModal(true)}>
            Importar Registros (UBICACION)
          </Button>
        </Col>
      </Row>
      {mostrarImportarRegistrosModal && (
        <ImportarRegistrosModal handleClose={e => setMostrarImportarRegistrosModal(false)} show={mostrarImportarRegistrosModal} tipoRegistro='U' />
      )}
    </>
  )
}

export default UbicacionSection
